<template>
  <div class="table-width">
    <cTable
      :fields="fields"
      :modals="modals"
      :methods="methods"
      :footer="footer"
      :config="config"
      ref="table"
    >
    </cTable>
  </div>
</template>
<script>
import cTable from "@/base/common/index";
import {
  getAbnormalOrder,
  addRemark,
  addFinishTime
} from "@/api/forecastManagement/subcontractForecastList";
export default {
  props: {
    row: Array,
    airway_number: String
  },
  components: {
    cTable
  },
  mounted() {
    this.$refs.table.list = this.row;
  },
  data() {
    let that = this;
    return {
      config: {
        resize: false,
        slot: "div"
      },
      methods: {
        getAbnormalOrder,
        addRemark,
        addFinishTime
      },
      footer: {
        show: () => false
      },
      modals: {
        show: {
          config: {
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            // footer: {
            //   show: true
            // },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("bagCode"),
                key: "package_number",
                align: "center",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        remark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$parent.list.forEach(el => {
                    if (el._XID == row._XID) {
                      el[row.type] = row.remark;
                    }
                  });
                  // this.getList();
                  close();
                });
            }
          },
          config: {
            rules: {
              remark: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remark: 24 }],
          fields: [
            {
              key: "remark",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        settime: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addFinishTime", row, true)
                .then(e => {
                  this.$parent.list.forEach(el => {
                    if (el._XID == row._XID) {
                      el.complete_time = row.complete_time;
                    }
                  });
                  // this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 400
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              complete_time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [{ complete_time: 24 }],
          fields: [
            {
              key: "complete_time",
              name: () =>
                this.$t("select") + this.$t("complete") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return (
                  this.$t("select") + this.$t("complete") + this.$t("time")
                );
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                },
                clearable: false
              }
            }
          ]
        }
      },
      fields: [
        {
          name: () => this.$t("shipmentBatch"),
          key: "batch_name",
          minWidth: 80
        },
        {
          name: () => this.$t("shipmentTicket"),
          key: "awbTotal",
          minWidth: 80
        },
        // {
        //   name: () => this.$t("shipmentNumber") + "(PCS)",
        //   key: "deliver_weight",
        //   minWidth: 130
        // },
        {
          name: () => this.$t("shipmentTime"),
          key: "outbound_time",
          minWidth: 150
        },
        {
          name: () => this.$t("customsBill"),
          key: "packing_number",
          minWidth: 130
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          minWidth: 130
        },
        {
          name: () => this.$t("takeOffTime"),
          key: "depart_date",
          minWidth: 150
        },
        {
          name: () => this.$t("arrivalTime"),
          key: "arrival_date",
          minWidth: 150
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          minWidth: 150
        },
        {
          name: () => this.$t("receiptTime"),
          key: "pod_time",
          minWidth: 150
        },
        {
          name: () => this.$t("onTheWayTicket"),
          key: "onTheWay",
          minWidth: 100
        },
        {
          name: () => this.$t("receiptTicket"),
          key: "podTotal",
          minWidth: 100
        },
        {
          name: () => this.$t("whether") + this.$t("abnormal"),
          key: "is_exception",
          minWidth: 100
        },
        {
          name: () => this.$t("abnormal") + this.$t("Votes"),
          key: "exceptionTotal",
          minWidth: 100,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page.getModal("show").open(row.airway_number, function() {
                this.$page
                  .handleRequestMethods(
                    "getAbnormalOrder",
                    {
                      packing_number: row.packing_number,
                      airway_number: that.airway_number
                    },
                    true,
                    true
                  )
                  .then(res => {
                    this.list = res.payload;
                  });
                this.setTitle(
                  this.$t("show") +
                    this.$t("abnormal") +
                    this.$t("order_t") +
                    row.packing_number
                );
              });
            }
          }
        },
        {
          name: () => this.$t("instruction"),
          key: "remark_instruction",
          minWidth: 100,
          component: "a",
          methods: {
            click({ row }) {
              let data = {
                airway_number: that.airway_number,
                packing_number: row.packing_number,
                remark: row.remark_instruction,
                type: "remark_instruction",
                _XID: row._XID
              };
              this.$page.getModal("remark").open(data, function() {
                this.setTitle(
                  row.remark_instruction
                    ? this.$t("update")
                    : this.$t("add") + this.$t("instruction")
                );
              });
            },
            render({ row }) {
              return row.remark_instruction
                ? row.remark_instruction
                : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("warehouse_t") + this.$t("order_desc"),
          key: "warehouse_remark",
          minWidth: 100
        },
        {
          name: () => this.$t("orther") + this.$t("order_desc"),
          key: "other_remark",
          minWidth: 100,
          component: "a",
          methods: {
            click({ row }) {
              let data = {
                airway_number: that.airway_number,
                packing_number: row.packing_number,
                remark: row.other_remark,
                type: "other_remark",
                _XID: row._XID
              };
              this.$page.getModal("remark").open(data, function() {
                this.setTitle(
                  row.other_remark
                    ? this.$t("update")
                    : this.$t("add") + this.$t("orther") + this.$t("order_desc")
                );
              });
            },
            render({ row }) {
              return row.other_remark ? row.other_remark : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("complete") + this.$t("time"),
          key: "complete_time",
          minWidth: 150,
          component: "Button",
          bind: {
            type: "success",
            size: "small"
          },
          methods: {
            click({ row }) {
              let data = {
                airway_number: that.airway_number,
                packing_number: row.packing_number,
                complete_time: row.complete_time
                  ? row.complete_time
                  : new Date(),
                _XID: row._XID
              };
              this.$page.getModal("settime").open(data, function() {
                this.setTitle(
                  row.complete_time
                    ? this.$t("update")
                    : this.$t("add") + this.$t("complete") + this.$t("time")
                );
              });
            },
            render({ row }) {
              return row.complete_time ? row.complete_time : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("addReceipt"),
          key: "sign_receipt",
          minWidth: 100
        }
      ]
    };
  }
};
</script>
<style>
/* .table-width {
  width: 100%;
  overflow: hidden;
} */
.vxe-body--expanded-cell {
  background: #f5f5f5;
  padding: 15px 0 0;
}
</style>
